<template>
    <div class="person-afil">
        <span class="blue-red-hover-text" @click="FIOclickHandle()">
            <slot>{{fio}}</slot>
        </span>

        <afilNetWorkTooltip v-if="showAfilNetworkTooltip" :inn="inn" :fio="fio" />

        <modal :printButton="true" :downloadButton="true" v-if="showModal" :close="() => { this.showModal = false }">
            <div slot="modalHeader">Аффилированность</div>
            <div slot="modalBody" style="padding: 15px 15px 5px">
                <div><b>ФИО:</b> {{onlyFirstLetterBig(fio)}}</div>
                <div><b>ИНН:</b> {{inn}}</div>
                <div>
                    <div v-if="loading">
                        <shestirenka/>
                    </div>
                    <div v-else-if="afilData">
                        <div v-if="afilData.upr.length && afilData.uchr.length">
                            <massFactor v-if="afilData.uchr.filter(e => !e.stakeholder_date_end).length >= 5">
                                Является учредителем в {{afilData.uchr.filter(e => !e.stakeholder_date_end).length}} ЮЛ и имеет признаки «массового учредителя».
                            </massFactor>
                            <massFactor v-if="afilData.upr.filter(e => !e.stakeholder_date_end).length >= 10">
                                Является руководителем в {{afilData.upr.filter(e => !e.stakeholder_date_end).length}} ЮЛ и имеет признаки «массового руководителя».
                            </massFactor>
                        </div>
                        <div v-if="afilData.upr && afilData.upr.length">
                            <p class="type-header">{{typeName("upr")}}</p>
                            <personAfilTable :afilArray="afilData.upr"/>
                            <personAfilStats :afilArray="afilData.upr" :type="'upr'"/>
                        </div>
                        <div v-if="afilData.uchr && afilData.uchr.length">
                            <p class="type-header">{{typeName("uchr")}}</p>
                            <personAfilTable :afilArray="afilData.uchr"/>
                            <personAfilStats :afilArray="afilData.uchr" :type="'uchr'"/>
                        </div>
                        <div v-if="afilData.mbupr && afilData.mbupr.length">
                            <p class="type-header">{{typeName("mbupr")}}</p>
                            <personAfilTable :afilArray="afilData.mbupr"/>
                            <personAfilStats :afilArray="afilData.mbupr" :type="'mbupr'"/>
                        </div>
                        <div v-if="afilData.mbuchr && afilData.mbuchr.length">
                            <p class="type-header">{{typeName("mbuchr")}}</p>
                            <personAfilTable :afilArray="afilData.mbuchr"/>
                            <personAfilStats :afilArray="afilData.mbuchr" :type="'mbuchr'"/>
                        </div>
                        <div v-if="afilData.upr_history && afilData.upr_history.length">
                            <p class="type-header">{{typeName("upr_history")}}</p>
                            <personAfilTable :afilArray="afilData.upr_history"/>
                            <personAfilStats :afilArray="afilData.upr_history" :type="'upr_history'"/>
                        </div>
                        <div v-if="afilData.uchr_history && afilData.uchr_history.length">
                            <p class="type-header">{{typeName("uchr_history")}}</p>
                            <personAfilTable :afilArray="afilData.uchr_history"/>
                            <personAfilStats :afilArray="afilData.uchr_history" :type="'uchr_history'"/>
                        </div>
                        <div v-if="history">
                            <p class="type-header">Исторические связи</p>
                            <personAfilTable :afilArray="history.ul"/>
                            <personAfilStats :afilArray="history.ul" :type="'history'"/>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import styled from 'vue-styled-components'
import modal from '@/components/ui/modal.vue'
import shestirenka from '@/components/ui/shestirenkaLoader.vue'
import afilNetWorkTooltip from '@/components/ui/afilNetworkTooltip/afilNetworkTooltip.vue'
import personAfilTable from './personAfilTable.vue'
import personAfilStats from './personAfilStats.vue'
import axios from 'axios'
import { onlyFirstLetterBig } from '@/helpers.ts'

const massFactor = styled.div`
    color: red;
    border: 0;
    margin: 10px 0;
    font-weight: 300;
`

export default {
    name: 'personAfil',
    components: {
        modal,
        shestirenka,
        personAfilTable,
        personAfilStats,
        afilNetWorkTooltip,
        massFactor
    },
    props: ['inn', 'fio', 'showAfilNetworkTooltip'],
    data() {
        return {
            showModal: false,
            loading: false,
            afilData: null,
            history: false
        }
    },
    methods: {
        FIOclickHandle() {
            
            if(this.inn) {

                this.loading = true
                this.showModal = true
                axios({
                    url: `${window.api_pro}company/${this.$props.inn}/afil?demo=1&rtype=fl&group_by=shtype&name=${this.$props.fio}${window.refresh_cache ? '&_refresh_cache=true' : ''}`,
                    headers: {
                        Authorization: `Bearer ${window.apiSession}`
                    }
                }).then(res => {
                    if (res.data.status.code == 204 || res.data.data.length == 0) {
                        this.$store.dispatch('showErrorPopUp', 'Данные не найдены')
                    } else if (res.data.status.code != 200) {
                        this.$store.dispatch('showErrorPopUp', 'Ошибка API')
                    } else {
                        // person_affil.report.render(result.data);
                        this.afilData = res.data.data
                    }
                }).finally(() => {
                    this.loading = false
                })


                this.$store.dispatch("RomAPI", {
                    method: "affil_history",
                    data: { inn_fl: this.$props.inn.toString() }
                }).then(e => {
                    if(e.data.data && e.data.data.count){
                        this.history = e.data.data
                    }
                })
            }
            
        },
        onlyFirstLetterBig(name) {
            const fio = name.split(' ').map(n => this.capitalize(n.toLowerCase()))
            return fio.join(' ')
        },
        typeName(type) {
            switch (type) {
                case 'mbuchr': return 'Может являться учредителем (совпадение по ФИО)'; break;
                case 'mbupr': return 'Может являться руководителем (совпадение по ФИО)'; break;
                case 'uchr': return 'Является/являлся учредителем (совпадение по ИНН)'; break;
                case 'upr': return 'Является/являлся руководителем (совпадение по ИНН)'; break;
                case 'uchr_history': return 'Являлся учредителем (совпадение по ИНН)'; break;
                case 'upr_history': return 'Являлся руководителем (совпадение по ИНН)'; break;
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.person-afil
    color: initial
    font-weight: initial
    // .fas.fa-project-diagram
    //     @extend .blue-red-hover-text
    //     font-weight: 600
.type-header
    border-bottom: 1px solid #005fb3
    color: #005fb3
    font-size: 20px
    margin: 30px 0 10px 0
.tooltip-link
    color:#000 !important
    cursor: default !important
    font-weight: normal !important
    span.blue-red-hover-text
        font-weight: bold !important
</style>